/* import __COLOCATED_TEMPLATE__ from './select-kit-create-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const SelectKitCreateRow = dt7948.c(class SelectKitCreateRow extends SelectKitRowComponent {}, [classNames("create")]);
export default SelectKitCreateRow;